import styled from "styled-components";

export const Container = styled.div`
  width: 98vw;
  height: max-content;
  margin-top: 20px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  align-items: center;

  .main {
    width: 290px;
    margin: 23px 12px;
    border: 1px solid var(--ghost-white);
    border-radius: 6px;
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    background-color: var(--fair-pink);

    @media screen and (max-width: 490px) {
      width: 270px;
    }

    @media screen and (max-width: 430px) {
      width: 260px;
    }

    @media screen and (max-width: 350px) {
      width: 250px;
    }

    .drinkName {
      width: 90%;
      text-decoration: underline var(--seal-brown);
      font-weight: 700;
      text-align: center;
      letter-spacing: 0.2rem;
      color: var(--seal-brown);
    }


    .first-brewed {
      width: 90%;
      text-align: right;
      color: var(--autumn-fern);
      font-weight: 700;
      border-right: 1px solid var(--autumn-fern);
    }

    .viewMore {
      width: 90%;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      background-color: var(--matterhorn);
      color: var(--snow-flurry);

      span {
        display: flex;
        justify-content: flex-start;
        align-items: center;


        svg {
          width: 2.5rem;
          height: 2rem;
          cursor: pointer;
        }
      }
    }

    .description {
      width: 90%;
      margin: 0;
      padding: 10px;
      border: none;
      white-space: wrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: var(--ghost-white);
      background-color: var(--matterhorn);
    }

    img {
      width: 100px;
      height: 200px;
      padding: 10px;
    }

    .volume {
      width: 90%;
      color: var(--black-pearl);
      font-weight: 700;
      border-left: 1px solid var(--black-pearl);
    }

    /* section {
    width: 400px;
    height: 410px;
    border-radius: 6px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--mint-cream);

    .buttonOne {
      margin: 0;
      padding-right:10px;
      box-shadow: 0 0 0;
      display: flex;
      align-items: flex-end;
      background: transparent;
    }

    .buttonTwo {
      margin: 0;
      box-shadow: 0 0 0;
      display: flex;
      align-items: center;
      background: transparent;
    }

    .buttonThree {
      margin: 0;
      padding-left: 10px;
      box-shadow: 0 0 0;
      display: flex;
      align-items: flex-start;
      background: transparent;
    }

    .closeModal {
      margin: 0;
      padding-right: 18px;
      box-shadow: 0 0 0;
      display: flex;
      align-items: flex-end;
      background: transparent;

      svg {
        width: 30px;
        height: 30px;
        cursor: pointer;
        color: var(--red);
      }      
    }

    aside {
      width: 100%;
      display: flex;
      flex-flow: column wrap;
      justify-content: center;
      align-items: center;

      .linkOne {
        margin: 0;
        padding-left:10px;
        box-shadow: 0 0 0;
        display: flex;
        align-items: flex-start;
        background: transparent;
      }

      .linkTwo {
        margin: 0;
        padding-right:10px;
        box-shadow: 0 0 0;
        display: flex;
        align-items: center;
        background: transparent;
      }

      .linkThree {
        margin: 0;
        padding-right:10px;
        box-shadow: 0 0 0;
        display: flex;
        align-items: flex-end;
        background: transparent;
      }

      a {
        background-color: var(--soft-amber);
        color: var(--ghost-white);
        width: 60%;
        height: 40px;
        margin: 10px 0;
        border-radius: 8px;
        text-align: center;
        line-height: 40px;
        font-family: "PT Serif",serif;
        font-size: 1rem;
        transition: 1.1s;
      }
    }
  } */

  .buttonDivision {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      position: relative;

      button {
        width: 100%;
        margin: 2px;
        padding: 0 10px;
        color: var(--snow-flurry);
        position: relative;
        left: 71px;

        @media screen and (max-width: 490px) {
          left: 60px;
        }

        @media screen and (max-width: 430px) {
          left: 55px;
        }

        @media screen and (max-width: 350px) {
          left: 49px;
        }
      }
    }
`;

export const Pages = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 50px;

  button {
    width: 20%;
    min-width: 80px;
    max-width: 150px;
  }
`;

export const Foot = styled.footer`
  width: 100%;
  padding: 0 0 30px 0;
  display: flex;
  justify-content: center;

  a {
    height: 30px;
    width: 60px;
    border-radius: 20%;
    font-size: 2rem;
    text-align: center;
    line-height: 30px;
    background-color: var(--seal-brown);
    color: var(--snow-flurry);
  }
`;
